module.exports = __webpack_public_path__ + "static/rera-certificate-749848209b4a1ef0faa1b1b8156b9ee6.pdf";